import { AcceptedResponse, TestUserImportResult, type TestUserImportRequest, LoginResponse, TesterOptions, TestingStatus, TestUser, TestUserCsvResult, TestUserList, type IdentitySwitchRequest, type TestUserCreate, type TestUserCsvImport } from '@regigov/contracts';
import { ApiError, api, getToken } from './client';

/** Only exists when the API runs with TESTING_MODE=true (docs/testing-mode.md). */
export const testingApi = {
  status: () => api('/testing/status', TestingStatus),
  users: () => api('/testing/users', TestUserList),
  /** Test admin: add one user. */
  createUser: (body: TestUserCreate) => api('/testing/users', TestUser, { method: 'POST', body: JSON.stringify(body) }),
  /** Test admin: add every user in a CSV, or none if any row has a problem (422 lists them). */
  importCsv: (body: TestUserCsvImport) => api('/testing/users/import-csv', TestUserCsvResult, { method: 'POST', body: JSON.stringify(body) }),
  /** Test admin: email the user a new set-password link. */
  /** Test admin: the CSV of every portal-added account, password hashes included, as a file to save. */
  exportCsv: async (): Promise<{ blob: Blob; filename: string }> => {
    const token = getToken();
    const res = await fetch('/api/testing/export', { headers: token ? { authorization: `Bearer ${token}` } : {} });
    if (!res.ok) throw new ApiError(res.status, { type: 'about:blank', title: res.statusText, status: res.status });
    const filename = /filename="([^"]+)"/.exec(res.headers.get('content-disposition') ?? '')?.[1];
    if (!filename) throw new Error('The export had no file name');
    return { blob: await res.blob(), filename };
  },
  /** Test admin: preview (apply false) or apply an export file. Problems are a 422 listing each one. */
  importUsers: (body: TestUserImportRequest) => api('/testing/import', TestUserImportResult, { method: 'POST', body: JSON.stringify(body) }),
  resendInvitation: (id: string) => api(`/testing/users/${id}/invitation`, AcceptedResponse, { method: 'POST' }),
  options: () => api('/testing/me/options', TesterOptions),
  /** Testers only. The reply is a new sign-in for the new role and organisation. */
  switchIdentity: (body: IdentitySwitchRequest) => api('/testing/me/identity', LoginResponse, { method: 'POST', body: JSON.stringify(body) }),
};
